/**
 * Record app — /apps/session-import/*
 *
 * One job: bring the results of a prioritization that already happened —
 * a spreadsheet ranking, a scoring workbook — onto the canonical record as
 * a real session. One screen driving four steps (C Mode maximum is four).
 * Steering spec: PRD-session-results-import.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import SessionImportScreen from './SessionImportScreen';

export default function SessionImportApp() {
  const app = getAppDefinition('session-import')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<SessionImportScreen />} />
        <Route path="*" element={<Navigate to="/apps/session-import" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
